import { syncAction } from '@/lib/action';

export const loadAllConfigsAction = syncAction('JE_FIELD_REARRANGEMENT/LOAD_ALL_CONFIGS');
export const swapCellsAction = syncAction('JE_FIELD_REARRANGEMENT/SWAP_CELLS');
export const hideCellAction = syncAction('JE_FIELD_REARRANGEMENT/HIDE_CELL');
export const showCellAction = syncAction('JE_FIELD_REARRANGEMENT/SHOW_CELL');
export const lockCellAction = syncAction('JE_FIELD_REARRANGEMENT/LOCK_CELL');
export const unlockCellAction = syncAction('JE_FIELD_REARRANGEMENT/UNLOCK_CELL');
export const resetFieldRearrangementAction = syncAction('JE_FIELD_REARRANGEMENT/RESET');

// Saga-triggering actions
export const fetchFieldRearrangementConfigAction = syncAction('JE_FIELD_REARRANGEMENT/FETCH_CONFIG');
export const persistFieldRearrangementConfigAction = syncAction('JE_FIELD_REARRANGEMENT/PERSIST_CONFIG');
